import { render, staticRenderFns } from "./Massages.vue?vue&type=template&id=4dff9eb8&"
import script from "./Massages.vue?vue&type=script&lang=js&"
export * from "./Massages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports